import { palette } from '@workspace/frontend-kit'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { RequesterEmailValidationVariant, VariantContentProps } from './props'
import { sxs } from './style'
import { ExpiredIcon } from '../../../assets/icons/icons'

export const VARIANTS: Record<RequesterEmailValidationVariant, VariantContentProps> = {
    success: {
        title: 'Merci d’avoir traité cette téléexpertise !',
        icon: <CheckCircleRoundedIcon sx={sxs.icon} color="inherit" />,
        color: palette.success[400],
        message: 'Votre choix a bien été enregistré, vous pouvez fermer cette page',
        note: 'Si vous l’avez transmise, vous recevrez l’avis de l’expert requis (compte-rendu et pièces jointes) sur votre messagerie sécurisée de santé',
    },
    outdated: {
        title: 'Oups, pour des raisons de sécurité, le lien de cette téléexpertise a expiré',
        icon: <InfoRoundedIcon sx={sxs.icon} color="inherit" />,
        color: 'primary.main',
        message:
            'Veuillez prendre contact avec l’établissement pour que l’effecteur puisse régénérer l’envoi du mail, si sa demande est toujours d’actualité',
        note: null,
    },
    invalid: {
        title: 'Oups, il semble que la page n’existe pas',
        icon: <ExpiredIcon sx={{ fontSize: '4.5rem' }} color="inherit" />,
        color: 'primary.main',
        message: null,
        note: 'Erreur 404',
    },
    error: {
        title: 'Merci d’avoir traité cette téléexpertise !',
        icon: <ErrorRoundedIcon sx={sxs.icon} color="inherit" />,
        color: palette.error[400],
        message:
            'Une anomalie a empêché l’enregistrement, veuillez réessayer. Si l’erreur persiste, contactez l’assistance',
        note: null,
    },
}

export const VariantContent = ({ title, icon, color, message, note }: VariantContentProps) => (
    <>
        <Typography component="h1" sx={sxs.title}>
            {title}
        </Typography>
        <Box sx={{ width: '100%', justifyContent: 'center' }}>
            <Box sx={[sxs.icon, { color }]}>{icon}</Box>
            {message && (
                <Typography component="p" sx={[sxs.message, { color }]}>
                    {message}
                </Typography>
            )}
        </Box>
        {note && (
            <Typography component="p" sx={sxs.note}>
                {note}
            </Typography>
        )}
    </>
)
